module.exports = ".l-wrap {\r\n  height: 100%;\r\n}\r\n  .l-wrap .l-wrap__inner-app {\r\n    width: 100%;\r\n    min-height: calc(100% - 60px);\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex\r\n  }\r\n  .l-wrap .l-wrap__column.-is-left-app {\r\n    -webkit-box-flex: 1;\r\n    -ms-flex: 1 0 auto;\r\n    flex: 1 0 auto;\r\n    max-width: 250px;\r\n    min-width: 186px;\r\n    background-color: #40516d;\r\n  }\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main